import { Input } from "components/ui/inputs/Input"
import type { useCategorySelection } from "hooks/categorySelection.hook"
import type { TDimensions } from "types/modelNumbers.type"
import { Image } from "./layout/Image/Image"
import { Categories } from "./layout/Categories/Categories"
import { Dimensions } from "./layout/Dimensions/Dimensions"
import style from "./ModelNumberStep.module.scss"

const { modelNumberStep, inputBlock, content } = style

type Props = {
	setCroppedImageUrl: (url: string | null) => void
	croppedImageUrl: string | null
	modelNumberName: string
	setModelNumberName: (name: string) => void
	categorySelection: ReturnType<typeof useCategorySelection>
	dimensions: TDimensions
	onDimensionsChange: (dimensions: TDimensions) => void
	showValidation: boolean
}

export const ModelNumberStep = ({
	setCroppedImageUrl,
	croppedImageUrl,
	modelNumberName,
	setModelNumberName,
	categorySelection,
	dimensions,
	onDimensionsChange,
	showValidation,
}: Props) => {
	return (
		<div className={modelNumberStep}>
			<div className={inputBlock}>
				<span>Model number</span>
				<Input
					value={modelNumberName}
					onChange={(e) => setModelNumberName(e.target.value)}
					status={showValidation && !modelNumberName.trim() ? "error" : undefined}
				/>
			</div>
			<div className={content}>
				<Image onImageSave={setCroppedImageUrl} croppedImageUrl={croppedImageUrl} showValidation={showValidation} />
				<Categories categorySelection={categorySelection} />
				<Dimensions dimensions={dimensions} onDimensionsChange={onDimensionsChange} showValidation={showValidation} />
			</div>
		</div>
	)
}
